import { $cece } from "./index";

export const getCECE = async () => {
	const { data } = await $cece.get(
		"api/Rotatia/ListaConsilierilorDinLocalitate?alegereId=19&scrutinTipId=14&raionId=115&localitateId=1311"
	);

	return data;
};
